// extracted by mini-css-extract-plugin
export default {"option_check":"ExportText_option_check__2y6zA","btn_style":"ExportText_btn_style__UKA6L","texts_format":"ExportText_texts_format__8yH-F"};